export const CONSTS = {
  SOURCE: $localize`Source`.toUpperCase() + ':',
  EVENT: $localize`Event`.toUpperCase() + ':',
  USER_ID: $localize`User Id`.toUpperCase() + ':',
};
